// Third-party packages
import {
	EnumEnvironments,
} from '@enums/environments.enum';
import {
	COMPANY_ROUTES,
} from '@routes/lpdipro/private/company';
import {
	DEMAND_ROUTES,
} from '@routes/lpdipro/private/demands';
import {
	OFFER_ENTRY_ROUTES,
} from '@routes/lpdipro/private/offer-entry';
import {
	SPECIFICATION_ROUTES,
} from '@routes/lpdipro/private/specification';
import {
	TEST_ROUTES,
} from '@routes/lpdipro/private/tests';
import {
	PATHS,
} from '@routes/paths';
import {
	lazy,
} from 'react';
import {
	Navigate,
} from 'react-router-dom';

// LAZY LOADING
const PageAppPrivate = lazy(() =>
	import('@layouts/Pages/PageAppPrivate').then((module) => ({
		default: module.PageAppPrivate,
	})),
);
const PageOffersMassUpdate = lazy(() =>
	import('@layouts/Pages/PageOffersMassUpdate').then((module) => ({
		default: module.PageOffersMassUpdate,
	})),
);
const PageDemand = lazy(() =>
	import('@layouts/Pages/PageDemand').then((module) => ({
		default: module.PageDemand,
	})),
);
const PageDemands = lazy(() =>
	import('@layouts/Pages/PageDemands').then((module) => ({
		default: module.PageDemands,
	})),
);
const PageError = lazy(() =>
	import('@layouts/Pages/PageError').then((module) => ({
		default: module.PageError,
	})),
);
const PageLogout = lazy(() =>
	import('@layouts/Pages/PageLogout').then((module) => ({
		default: module.PageLogout,
	})),
);
const PageExportPDF = lazy(() =>
	import('@layouts/Pages/PageExportPDF').then((module) => ({
		default: module.PageExportPDF,
	})),
);
const PageHome = lazy(() =>
	import('@layouts/Pages/PageHome').then((module) => ({
		default: module.PageHome,
	})),
);
const PageMatchingOfferDemands = lazy(() =>
	import('@layouts/Pages/PageMatchingOfferDemands').then((module) => ({
		default: module.PageMatchingOfferDemands,
	})),
);
const PageObservatoryReport = lazy(() =>
	import('@layouts/Pages/PageObservatoryReport').then((module) => ({
		default: module.PageObservatoryReport,
	})),
);
const PageTests = lazy(() =>
	import('@layouts/Pages/PageTests').then((module) => ({
		default: module.PageTests,
	})),
);
const PageTestsIframe = lazy(() =>
	import('@layouts/Pages/PageTests/Iframe').then((module) => ({
		default: module.PageTestsIframe,
	})),
);
const PageOfferEntry = lazy(() =>
	import('@layouts/Pages/PageOfferEntry').then((module) => ({
		default: module.PageOfferEntry,
	})),
);
const PageSpecifications = lazy(() =>
	import('@layouts/Pages/PageSpecifications').then((module) => ({
		default: module.PageSpecifications,
	})),
);
const PageSpecification = lazy(() =>
	import('@layouts/Pages/PageSpecification').then((module) => ({
		default: module.PageSpecification,
	})),
);
const PageCompany = lazy(() =>
	import('@layouts/Pages/PageCompany').then((module) => ({
		default: module.PageCompany,
	})),
);

export const PRIVATE_ROUTES = [
	{
		element: <PageError />,
		path: PATHS.ERROR._ROOT,
	},
	{
		element: <PageHome />,
		path: PATHS.HOMEPAGE,
	},
	{
		element: <Navigate to={PATHS.HOMEPAGE} />,
		path: '/',
	},
	{
		element: <PageObservatoryReport />,
		path: PATHS.OBSERVATORY.REPORT,
	},
	{
		children: DEMAND_ROUTES,
		element: <PageDemand />,
	},
	{
		element: <PageDemands />,
		path: PATHS.DEMANDS._ROOT,
	},
	{
		element: <PageMatchingOfferDemands />,
		path: PATHS.OFFERS.MATCHING_DEMANDS,
	},
	{
		children: OFFER_ENTRY_ROUTES,
		element: <PageOfferEntry />,
	},
	{
		element: <PageSpecifications />,
		path: PATHS.SPECIFICATIONS._ROOT,
	},
	{
		children: SPECIFICATION_ROUTES,
		element: <PageSpecification />,
	},
	{
		children: COMPANY_ROUTES,
		element: <PageCompany />,
	},
	{
		element: <PageOffersMassUpdate />,
		path: PATHS.OFFERS.MASS_UPDATE._ROOT,
	},
];

const PRIVATE_ROUTES_REDIRECT = [
	{
		element: <Navigate to={PATHS.HOMEPAGE} />,
		path: `${PATHS.LOGIN._ROOT}/*`,
	},
	{
		element: <PageError />,
		path: '*',
	},
	{
		element: <PageLogout />,
		path: PATHS.LOGOUT,
	},
];

let PRIVATE_ROUTES_GLOBAL = [
	{
		children: [
			...PRIVATE_ROUTES,
			...PRIVATE_ROUTES_REDIRECT,
		],
		element: <PageAppPrivate />,
	},
	// TO GET BACK TO @routes/lpdipro/private/tests FILE WHEN FIX IS DONE
	{
		element: <PageTestsIframe />,
		path: PATHS.TESTS.IFRAME,
	},
	{
		element: <PageExportPDF />,
		path: PATHS.OFFERS.EXPORT_PDF,
	},
];

export const PRIVATE_ROUTES_TESTS = [
	{
		children: TEST_ROUTES,
		element: <PageTests />,
	},
];

if (process.env.STONAL_ENV !== EnumEnvironments.PRODUCTION) {
	PRIVATE_ROUTES_GLOBAL = [
		...PRIVATE_ROUTES_GLOBAL,
		...PRIVATE_ROUTES_TESTS,
	];
}

export {
	PRIVATE_ROUTES_GLOBAL,
};

